export const CURRENCY_PREFIX = '@currency/';
export const CURRENCY_RATES = `${CURRENCY_PREFIX}RATES`;
export const CURRENCY_CLEAR = `${CURRENCY_PREFIX}CLEAR`;
